import { Navigate } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import PageMeta from '../../components/common/PageMeta';
import AuthLayout from './AuthPageLayout';
import SignInForm from '../../components/auth/SignInForm';

export default function SignIn() {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white dark:bg-gray-900">
        <p className="text-sm text-gray-600 dark:text-gray-400">Loading…</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <PageMeta
        title="Sign in | QC Lite"
        description="Sign in to QC Lite with your Google account."
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
